import React, { useEffect } from 'react';
import { useModal, setGlobalModalManager } from '../../hooks/useModal';
import Modal from './Modal';

interface ModalProviderProps {
  children: React.ReactNode;
}

const ModalProvider: React.FC<ModalProviderProps> = ({ children }) => {
  const modalManager = useModal();

  // Set the global modal manager instance
  useEffect(() => {
    setGlobalModalManager(modalManager);
  }, [modalManager]);

  return (
    <>
      {children}

      {/* Render all active modals */}
      {modalManager.modals.map((modal) => {
        const handleClose = () => {
          // Call the modal's onClose handler if provided
          modal.onClose?.();
          // Then close the modal
          modalManager.closeModal(modal.id);
        };

        return (
          <Modal
            key={modal.id}
            isOpen={modal.isOpen}
            title={modal.title}
            onClose={handleClose}
            size={modal.size}
            className={modal.className}
            preventClose={modal.preventClose}
          >
            {modal.content}
          </Modal>
        );
      })}
    </>
  );
};

export default ModalProvider;
